// src/components/Menu/menuConfig.ts
export interface MenuConfig {
  homePath: string;
  employeeHomePath: string;
  dashboardPath?: string;
  employeeDashboardPath?: string;
  orderPath: string;
  employeeOrderPath?: string;
  ledgerPath?: string;
  employeeLedgerPath?: string;
  settingsPath?: string;
  runningOrder?: string;
  toolsPath?: string;
  showDashboard?: boolean;
  showSettings?: boolean;
  showTools?: boolean;
  DailyReport?: string;
  Configurations?:string;
  Catalog?:string;
}

export const BUSINESS_MENUS: Record<string, MenuConfig> = {
  Laundry: {
    homePath: "/v1/home",
    employeeHomePath: "/v1/employee/home",
    dashboardPath: "/v1/dashboard",
    orderPath: "/v1/order",
    ledgerPath: "/v1/ledger",
    employeeLedgerPath: "/v1/employee/ledger",
    settingsPath: "/v1/edit/location",
    DailyReport:"/v1/sales-report",
    Configurations:"/v1/configuration",
    Catalog:"/v1/catalog",
    showDashboard: true,
    showSettings: true,
    showTools: false,

  },
  Carwash: {
    homePath: "/v1/new-order",
    employeeHomePath: "/v1/employee/new-order",
    dashboardPath: "/v1/dashboard",
    orderPath: "/v1/order-list",
    employeeOrderPath: "/v1/employee/order-list",
    settingsPath: "/v1/car-setting/car-branch",
    Configurations:"/v1/configuration",
    Catalog:"/v1/catalog",
    showDashboard: true,
    showSettings: true,
    showTools: false,
  },
  "Car wash": {
    homePath: "/v1/new-order",
    employeeHomePath: "/v1/employee/new-order",
    dashboardPath: "/v1/dashboard",
    orderPath: "/v1/order-list",
    employeeOrderPath: "/v1/employee/order-list",
    settingsPath: "/v1/car-setting/car-branch",
    Configurations:"/v1/configuration",
    Catalog:"/v1/catalog",
    showDashboard: true,
    showSettings: true,
    showTools: false,
  },
  "Vechicle retailer": {
    homePath: "/v1/vechicle-home",
    employeeHomePath: "/v1/employee/home",
    dashboardPath: "/v1/dashboard",
    orderPath: "/v1/order",
    employeeOrderPath: "/v1/employee/order",
    ledgerPath: "/v1/ledger",
    employeeLedgerPath: "/v1/employee/ledger",
    settingsPath: "/v1/setting/vechicle-branch",
    Configurations:"/v1/configuration",
    toolsPath: "/v1/tools",
    Catalog:"/v1/catalog",
    showDashboard: true,
    showSettings: true,
    showTools: true,
  },
  Saloon: {
    homePath: "/v1/saloon-Home",
    employeeHomePath: "/v1/employee/saloon-Home",
    // dashboardPath: "/v1/saloon-deshboard",
    dashboardPath: "/v1/dashboard",
    employeeDashboardPath: "/v1/employee/saloon-deshboard",
    orderPath: "/v1/saloon-order",
    employeeOrderPath: "/v1/employee/order",
    ledgerPath: "/v1/ledger",
    employeeLedgerPath: "/v1/employee/ledger",
    settingsPath: "/v1/saloonedit/style-branch",
    toolsPath: "/v1/tools",
    DailyReport:"/v1/sales-report",
    Catalog:"/v1/catalog",
    Configurations:"/v1/configuration",
    showDashboard: true,
    showSettings: true,
    showTools: true,
  },
  Restaurant: {
    homePath: "/v1/Reshome",
    employeeHomePath: "/v1/employee/Reshome",
    dashboardPath: "/v1/dashboard",
    // dashboardPath: "/v1/Resdeshboard",
    orderPath: "/v1/Resorders",
    employeeOrderPath: "/v1/employee/Resorders",
    runningOrder: "/v1/Resrunning-order",
    // ledgerPath: "/v1/ledger",
    // employeeLedgerPath: "/v1/employee/ledger",
    settingsPath: "/v1/edit/location",
    showDashboard: true,
    showSettings: true,
    showTools: true,
    DailyReport:"/v1/sales-summary",
    Configurations:"/v1/configuration",
    Catalog:"/v1/catalog",
  },
};
